module.exports = __webpack_public_path__ + "static/media/AllianceNo2-Regular.7cebfa56.woff";